import React from "react";
import { styled } from "styled-components";

interface Props {
  color: string;
  label: string;
  className?: string;
}

const StyledBadge = styled.div`
  height: 25px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  color: var(--gray500);
  flex-grow: 0;
  border-radius: 3px;
`;

const Badge = (props: Props) => {
  const { color, label, className } = props;
  return (
    <div className={className}>
      <StyledBadge style={{ backgroundColor: color }}>{label}</StyledBadge>
    </div>
  );
};

export default Badge;
